<template>

  <SideBarAsideFix/>

  <div class="content pd-0" style="border: 1px solid #ccc;">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">
      <div class="container pd-x-0">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Harvest DataCenter</li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1">Welcome to Dashboard</h4>
          </div>
          <div class="d-none d-md-block">
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i>
              Email
            </button>
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer"
                                                                                 class="wd-10 mg-r-5"></i> Print
            </button>
            <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="file"
                                                                                   class="wd-10 mg-r-5"></i> Generate
              Report
            </button>
          </div>
        </div>


        <div class="row row-xs">
          <div class="col-sm-6 col-lg-3">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">WATER BAPTISED</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0.81%</h3>
                <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-success d-inline-flex align-items-center">1.2% <ion-icon
                    name="arrow-up-outline"></ion-icon></span> than last week
                </p>
              </div>
              <div class="chart-three">
                <div id="flotCharta" class="flot-chart ht-30"></div>
              </div><!-- chart-three -->
            </div>
          </div>
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">NOT BAPTISED</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0,037</h3>
                <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-danger d-inline-flex align-items-center">0.7% <ion-icon
                    name="arrow-down-outline"></ion-icon></span> than last week
                </p>
              </div>
              <div class="chart-three">
                <div id="flotChartb" class="flot-chart ht-30"></div>
              </div><!-- chart-three -->
            </div>
          </div>
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">MEMBERSHIP CLASS</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0,306</h3>
                <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-danger d-inline-flex align-items-center">0.3% <ion-icon
                    name="arrow-down-outline"></ion-icon></span> than last week
                </p>
              </div>
              <div class="chart-three">
                <div id="flotChartc" class="flot-chart ht-30"></div>
              </div><!-- chart-three -->
            </div>
          </div>
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Total Members</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">1,650</h3>
                <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-success d-inline-flex align-items-center">2.1% <ion-icon
                    name="arrow-up-outline"></ion-icon></span> than last week
                </p>
              </div>
              <div class="chart-three">
                <div id="flotChartd" class="flot-chart ht-30"></div>
              </div><!-- chart-three -->
            </div>
          </div>
        </div>


        <div class="row row-xs mg-t-10">
          <div class="col-lg-8 col-xl-9">
            <div class="card">
              <div
                  class="card-header bd-b-0 pd-t-20 pd-lg-t-25 pd-l-20 pd-lg-l-25 d-flex flex-column flex-sm-row align-items-sm-start justify-content-sm-between">
                <div>
                  <h6 class="mg-b-5">This Year First Time Worshipper Metrics</h6>
                  <p class="tx-12 tx-color-03 mg-b-0">New Members, First Time Worshipper, statistical report by months
                    for the current year.</p>
                </div>
                <div class="btn-group mg-t-20 mg-sm-t-0">
                  <button class="btn btn-xs btn-white btn-uppercase">Day</button>
                  <button class="btn btn-xs btn-white btn-uppercase">Week</button>
                  <button class="btn btn-xs btn-white btn-uppercase active">Month</button>
                </div><!-- btn-group -->
              </div><!-- card-header -->
              <div class="card-body pd-lg-25">
                <div class="row align-items-sm-end">
                  <div class="col-lg-7 col-xl-8">
                    <div class="chart-six">
                      <canvas id="chartBar1"></canvas>
                    </div>
                  </div>
                  <div class="col-lg-5 col-xl-4 mg-t-30 mg-lg-t-0">
                    <div class="row">
                      <div class="col-sm-6 col-lg-12">
                        <div class="d-flex align-items-center justify-content-between mg-b-5">
                          <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-02 tx-semibold mg-b-0">Total This
                            Month</h6>
                          <span class="tx-10 tx-color-04">50% goal reached</span>
                        </div>
                        <div class="d-flex align-items-end justify-content-between mg-b-5">
                          <h5 class="tx-normal tx-rubik lh-2 mg-b-0">{{ firstTimerThisMonth }}</h5>
                          <h6 class="tx-normal tx-rubik tx-color-03 lh-2 mg-b-0"> {{ firstTimerThisMonthGoal }} </h6>
                        </div>
                        <div class="progress ht-4 mg-b-0 op-5">
                          <div class="progress-bar bg-teal wd-65p" role="progressbar" aria-valuenow="65"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-lg-12 mg-t-30 mg-sm-t-0 mg-lg-t-30">
                        <div class="d-flex align-items-center justify-content-between mg-b-5">
                          <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-02 tx-semibold mg-b-0">Total This
                            Year</h6>
                          <span class="tx-10 tx-color-04">45% goal reached</span>
                        </div>
                        <div class="d-flex justify-content-between mg-b-5">
                          <h5 class="tx-normal tx-rubik mg-b-0">{{ firstTimerThisYear }}</h5>
                          <h5 class="tx-normal tx-rubik tx-color-03 mg-b-0"><small>250,000</small></h5>
                        </div>
                        <div class="progress ht-4 mg-b-0 op-5">
                          <div class="progress-bar bg-orange wd-45p" role="progressbar" aria-valuenow="45"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-lg-12 mg-t-30">
                        <div class="d-flex align-items-center justify-content-between mg-b-5">
                          <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-02 tx-semibold mg-b-0">Passed
                            Foundation</h6>
                          <span class="tx-10 tx-color-04">20% goal reached</span>
                        </div>
                        <div class="d-flex justify-content-between mg-b-5">
                          <h5 class="tx-normal tx-rubik mg-b-0">{{ passedBfcThisYear }}</h5>
                          <h5 class="tx-normal tx-rubik tx-color-03 mg-b-0"><small>{{ firstTimerThisYear }}</small></h5>
                        </div>
                        <div class="progress ht-4 mg-b-0 op-5">
                          <div class="progress-bar bg-pink wd-20p" role="progressbar" aria-valuenow="20"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-lg-12 mg-t-30">
                        <div class="d-flex align-items-center justify-content-between mg-b-5">
                          <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-02 tx-semibold mg-b-0">Already
                            Serving</h6>
                          <span class="tx-10 tx-color-04">85% goal reached</span>
                        </div>
                        <div class="d-flex justify-content-between mg-b-5">
                          <h5 class="tx-normal tx-rubik mg-b-0">{{ alreadyServingThisYear }}</h5>
                          <h5 class="tx-normal tx-rubik tx-color-03 mg-b-0"><small> {{ firstTimerThisYear }} </small></h5>
                        </div>
                        <div class="progress ht-4 mg-b-0 op-5">
                          <div class="progress-bar bg-primary wd-85p" role="progressbar" aria-valuenow="85"
                               aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                    </div><!-- row -->

                  </div>
                </div>
              </div><!-- card-body -->
            </div><!-- card -->
          </div>
          <div class="col-md-6 col-lg-4 col-xl-3 mg-t-10 mg-lg-t-0">
            <div class="card">
              <div class="card-header">
                <h6 class="mg-b-0">Members Marital Status</h6>
              </div><!-- card-header -->
              <div class="card-body pd-lg-25">
                <div class="chart-seven">
                  <canvas id="chartDonut"></canvas>
                </div>
              </div><!-- card-body -->
              <div class="card-footer pd-20">
                <div class="row">
                  <div class="col-6">
                    <p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 tx-nowrap mg-b-5">Married</p>
                    <div class="d-flex align-items-center">
                      <div class="wd-10 ht-10 rounded-circle bg-pink mg-r-5"></div>
                      <h6 class="tx-normal tx-rubik mg-b-0"> {{ this.marital.married }}
                        <small class="tx-color-04"> {{ this.marital.marriedPercent }} %</small></h6>
                    </div>
                  </div>
                  <div class="col-6">
                    <p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Divorced</p>
                    <div class="d-flex align-items-center">
                      <div class="wd-10 ht-10 rounded-circle bg-primary mg-r-5"></div>
                      <h6 class="tx-normal tx-rubik mg-b-0">{{ this.marital.divorce }} <small class="tx-color-04">{{ this.marital.divorcePercent }}%</small></h6>
                    </div>
                  </div>
                  <div class="col-6 mg-t-20">
                    <p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Separated</p>
                    <div class="d-flex align-items-center">
                      <div class="wd-10 ht-10 rounded-circle bg-teal mg-r-5"></div>
                      <h6 class="tx-normal tx-rubik mg-b-0">{{ this.marital.separated}} <small class="tx-color-04">{{ this.marital.separatedPercent }}%</small></h6>
                    </div>
                  </div>
                  <div class="col-6 mg-t-20">
                    <p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Single</p>
                    <div class="d-flex align-items-center">
                      <div class="wd-10 ht-10 rounded-circle bg-orange mg-r-5"></div>
                      <h6 class="tx-normal tx-rubik mg-b-0">{{ this.marital.single}} <small class="tx-color-04">{{ this.marital.singlePercent}}%</small></h6>
                    </div>
                  </div>
                </div><!-- row -->
              </div><!-- card-footer -->
            </div><!-- card -->
          </div>


          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-100p">
              <NewMembers/>
            </div><!-- card -->
          </div>


          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-lg-100p">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Celebrants by months</h6>
                <ul class="list-inline d-flex mg-b-0">
                  <li class="list-inline-item d-flex align-items-center">
                    <span class="d-block wd-10 ht-10 bg-df-2 rounded mg-r-5"></span>
                    <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">This Month</span>
                  </li>
                  <li class="list-inline-item d-flex align-items-center mg-l-10">
                    <span class="d-block wd-10 ht-10 bg-df-3 rounded mg-r-5"></span>
                    <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">Next Month</span>
                  </li>
                </ul>
              </div><!-- card-header -->
              <div class="card-body pd-b-0">
                <div class="row mg-b-20">
                  <div class="col">
                    <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10"> {{ celebrantThisMonth }} <span
                        style="font-size: 0.9em">Celebrants</span> <small
                        class="tx-11 tx-success letter-spacing--2 d-inline-flex align-items-center">
                      <ion-icon name="arrow-up-outline"></ion-icon>
                      0.20%</small></h4>
                    <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">This Month</p>
                  </div>
                  <div class="col">
                    <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">{{ celebrantNextMonth }} <span
                        style="font-size: 0.9em">Celebrants</span> <small
                        class="tx-11 tx-danger letter-spacing--2 d-inline-flex align-items-center">
                      <ion-icon name="arrow-down-outline"></ion-icon>
                      1.04%</small></h4>
                    <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">Next Month</p>
                  </div>
                </div><!-- row -->
                <div class="chart-five">
                  <div>
                    <canvas id="chartBarHorizontal1"></canvas>
                  </div>
                </div>
              </div><!-- card-body -->
            </div>
          </div>


          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card card-body">
              <div class="media d-block d-sm-flex align-items-center">
                <div class="d-inline-block pos-relative">
                  <span class="peity-donut"
                        data-peity='{ "fill": ["#65e0e0","#e5e9f2"], "height": 110, "width": 110, "innerRadius": 46 }'>{{
                      this.bfcStatusYes
                    }},{{ this.bfcStatusNo }}</span>

                  <div class="pos-absolute a-0 d-flex flex-column align-items-center justify-content-center">
                    <h3 class="tx-rubik tx-spacing--1 mg-b-0"> {{ this.bfcStatusPercent }}%</h3>
                    <span class="tx-9 tx-semibold tx-sans tx-color-03 tx-uppercase">Completed</span>
                  </div>
                </div>
                <div class="media-body mg-t-20 mg-sm-t-0 mg-sm-l-20">
                  <h6 class="mg-b-5">Foundation School</h6>
                  <p class="lh-4 tx-12 tx-color-03 mg-b-15">Statistics of members who have completed foundation
                    school.</p>

                  <h3 class="tx-spacing--1 mg-b-0">

                    <a :href="`/users?bfc_status=yes`" class="tx-dark">
                      {{ this.bfcStatusYes }} <i class="far fa-thumbs-up tx-18 tx-info"> </i>
                    </a> :
                    <a :href="`/users?bfc_status=no`" class="tx-dark">
                      {{ this.bfcStatusNo }} <i class="far fa-thumbs-down tx-18 tx-pink"></i>
                    </a>

                    <small class="tx-13 tx-color-03"> / Out of {{ this.totalMembers }}</small>
                  </h3>
                </div><!-- media-body -->
              </div><!-- media -->
            </div>


            <div class="card card-body mg-t-10">
              <div class="media d-block d-sm-flex align-items-center">
                <div class="d-inline-block pos-relative">
                  <span class="peity-donut"
                        data-peity='{ "fill": ["#69b2f8","#e5e9f2"], "height": 110, "width": 110, "innerRadius": 46 }'>{{
                      this.waterBaptismYes
                    }},{{ this.waterBaptismNo }}</span>

                  <div class="pos-absolute a-0 d-flex flex-column align-items-center justify-content-center">
                    <h3 class="tx-rubik tx-spacing--1 mg-b-0"> {{ this.waterBaptismPercent }}%</h3>
                    <span class="tx-9 tx-semibold tx-sans tx-color-03 tx-uppercase">Reached</span>
                  </div>
                </div>
                <div class="media-body mg-t-20 mg-sm-t-0 mg-sm-l-20">
                  <h6 class="mg-b-5">Water Baptism </h6>
                  <p class="lh-4 tx-12 tx-color-03 mg-b-15">Statistics of members baptised with water by immersion</p>
                  <h3 class="tx-spacing--1 mg-b-0">

                    <a :href="`/users?water_baptism=yes`" class="tx-dark">
                      {{ this.waterBaptismYes }} <i class="far fa-thumbs-up tx-18 tx-info"> </i>
                    </a> :
                    <a :href="`/users?water_baptism=no`" class="tx-dark">
                      {{ this.waterBaptismNo }} <i class="far fa-thumbs-down tx-18 tx-pink"></i>
                    </a>

                    <small class="tx-13 tx-color-03"> / Out of {{ this.totalMembers }}</small>
                  </h3>
                </div><!-- media-body -->
              </div><!-- media -->
            </div>


            <div class="card card-body mg-t-10">
              <div class="media d-block d-sm-flex align-items-center">
                <div class="d-inline-block pos-relative">
                  <span class="peity-donut"
                        data-peity='{ "fill": ["#f77eb9","#e5e9f2"], "height": 110, "width": 110, "innerRadius": 46 }'>{{
                      this.bibleSchoolYes
                    }},{{ this.bibleSchoolNo }}</span>

                  <div class="pos-absolute a-0 d-flex flex-column align-items-center justify-content-center">
                    <h3 class="tx-rubik tx-spacing--1 mg-b-0"> {{ this.bibleSchoolPercent }}%</h3>
                    <span class="tx-9 tx-semibold tx-sans tx-color-03 tx-uppercase">Reached</span>
                  </div>
                </div>
                <div class="media-body mg-t-20 mg-sm-t-0 mg-sm-l-20">
                  <h6 class="mg-b-5">Word of Faith Bible Institute</h6>
                  <p class="lh-4 tx-12 tx-color-03 mg-b-15">Statistics of members who have attended Bible School</p>
                  <h3 class="tx-spacing--1 mg-b-0">

                    <a :href="`/users?wofbi_status=yes`" class="tx-dark">
                      {{ this.bibleSchoolYes }} <i class="far fa-thumbs-up tx-18 tx-info"> </i>
                    </a> :
                    <a :href="`/users?wofbi_status=no`" class="tx-dark">
                      {{ this.bibleSchoolNo }} <i class="far fa-thumbs-down tx-18 tx-pink"></i>
                    </a>

                    <small class="tx-13 tx-color-03"> / Out of {{ this.totalMembers }}</small>
                  </h3>
                </div><!-- media-body -->
              </div><!-- media -->
            </div>


          </div><!-- col -->


        </div><!-- row -->
      </div><!-- container -->

    </div>

  </div>


</template>

<script>

import visualizationMixin from "@/mixins/visualization-script";
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import footerScriptMixin from "@/mixins/footer-script";
import NewMembers from "./components/NewMembers.vue";
import serviceMixin from "@/mixins/contact-service";

// Down at your feet / You deseerve the glory
export default {
  name: "ContactDashboard",
  components: {NewMembers, SideBarAsideFix},
  mixins: [visualizationMixin, footerScriptMixin, serviceMixin],
  watch: {},
  data() {
    return {
      contacts: [],
      celebrantCount: [],
      celebrantThisMonth: 0,
      celebrantNextMonth: 0,

      bibleSchoolYes: 0,
      bibleSchoolNo: 0,
      bibleSchoolPercent: 0,

      waterBaptismYes: 0,
      waterBaptismNo: 0,
      waterBaptismPercent: 0,

      bfcStatusYes: 0,
      bfcStatusNo: 0,
      bfcStatusPercent: 0,

      marital: {
        "separated": 0,
        "divorce": 0,
        "single": 0,
        "married": 0,
        "separatedPercent": 0,
        "divorcePercent": 0,
        "singlePercent": 0,
        "marriedPercent": 0
      },

      totalMembers: 0,
      firstTimerThisMonth: 0,
      firstTimerThisMonthGoal: 0,
      firstTimerThisYear: 0,
      alreadyServingThisYear: 0,
      passedBfcThisYear: 0,
      isAdmin: '',
      userDetail: '',
      uploadStatus: '',
      months: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  created() {
    this.footerScript();
    this.asideBarScript();
    this.loadData();
  },
  methods: {
    async loadData() {

      // Celebrants by months
      let result = await this.getDashboardReport('birthday_month', '');
      let monthMap = {'1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0, '11': 0, '12': 0}
      if (result.data) {
        Object.keys(monthMap).forEach((mapKey) => {
          monthMap[mapKey] = result.data[mapKey];
        })
        Object.values(monthMap).forEach((count) => this.celebrantCount.push(count));
      }

      let month = (new Date()).getMonth();
      this.celebrantThisMonth = this.celebrantCount[month];
      this.celebrantNextMonth = this.celebrantCount[month + 1];

      // Bible School Insight
      let wofbiStatus = await this.getDashboardReport('wofbi_status', '');
      this.bibleSchoolNo = wofbiStatus.data['NO']
      this.bibleSchoolYes = wofbiStatus.data['YES']
      this.totalMembers = this.bibleSchoolNo + this.bibleSchoolYes;
      this.bibleSchoolPercent = Math.round((this.bibleSchoolYes / this.totalMembers) * 100);

      // Water Baptism Insight
      let waterBaptism = await this.getDashboardReport('water_baptism', '');
      this.waterBaptismNo = waterBaptism.data['NO']
      this.waterBaptismYes = waterBaptism.data['YES']
      this.waterBaptismPercent = Math.round((this.waterBaptismYes / this.totalMembers) * 100);

      // Membership class Insight
      let bfcStatus = await this.getDashboardReport('bfc_status', '');
      this.bfcStatusNo = bfcStatus.data['NO']
      this.bfcStatusYes = bfcStatus.data['YES']
      this.bfcStatusPercent = Math.round((this.bfcStatusYes / this.totalMembers) * 100);

      // Marital Status Insight
      let marital = await this.getDashboardReport('marital_status','');
      console.log(marital);
      let pieLabel = []
      let pieData = []
      let pieColor = []
      let totalData = 0;
      Object.keys(marital.data).forEach((key) => {
        pieLabel.push(key)
        pieData.push(marital.data[key])
        pieColor.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`)
        totalData += parseInt(marital.data[key])
      })
      let pieChartData = {"pieLabel": pieLabel, "pieData": pieData, "pieColor": pieColor}


      this.marital.separated = isNaN(marital.data['separated']) ? 0 : marital.data['separated'];
      this.marital.separatedPercent = Math.round((this.marital.separated / totalData) * 100);

      this.marital.divorce = isNaN(marital.data['DIVORCE']) ? 0 : marital.data['DIVORCE'];
      this.marital.divorcePercent = Math.round((this.marital.divorce / totalData) * 100);

      this.marital.single = isNaN(marital.data['single']) ? 0 : marital.data['single'];
      this.marital.singlePercent = Math.round((this.marital.single / totalData) * 100);

      this.marital.married = isNaN(marital.data['married']) ? 0 : marital.data['married'];
      this.marital.marriedPercent = Math.round((this.marital.married / totalData) * 100);


      // Marital page Display
      // this.bfcStatusNo = bfcStatus.data['NO']
      // this.bfcStatusYes = bfcStatus.data['YES']
      // this.bfcStatusPercent = Math.round((this.bfcStatusYes / this.totalMembers) * 100);


      // First Time Worshipper Chart
      let currentYear = (new Date()).getFullYear();
      let lastYear = currentYear - 1;
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let currentMonth = monthNames[(new Date()).getMonth()];

      let firstTimer = await this.getDashboardReport('first_attendance', lastYear.toString());
      let months =  [];
      let lastYearMonthlyData = [];
      let thisYearMonthlyData = [];
      Object.keys(firstTimer.data).forEach((month) => months.push(month));
      Object.values(firstTimer.data).forEach((data) => lastYearMonthlyData.push(parseInt(data)));


      firstTimer = await this.getDashboardReport('first_attendance', currentYear.toString());
      Object.values(firstTimer.data).forEach((data) => {
        thisYearMonthlyData.push(parseInt(data));
      });


      this.firstTimerThisMonth = (firstTimer.data[currentMonth] || 0).toString().padStart(5, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.firstTimerThisMonthGoal = ((firstTimer.data[currentMonth] || 0) * 2).toString().padStart(5, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.firstTimerThisYear = Object.values(firstTimer.data).reduce((acc, val) => acc + parseInt(val), 0).toString().padStart(5, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let alreadyServing = await this.getDashboardReport('already_serving', currentYear.toString());
      this.alreadyServingThisYear = Object.values(alreadyServing.data).reduce((acc, val) => acc + parseInt(val), 0).toString().padStart(5, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let passedBfc = await this.getDashboardReport('passed_bfc', currentYear.toString());
      this.passedBfcThisYear = Object.values(passedBfc.data).reduce((acc, val) => acc + parseInt(val), 0).toString().padStart(5, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      this.vizDashboardTwo(months, lastYearMonthlyData, thisYearMonthlyData, lastYear, currentYear,  this.celebrantCount, pieChartData);
    },
  }
}
</script>
<style>
@import 'http://app.wcicambridge.org/cdn/assets/css/dashforge.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';



/* Custom component elevation */
.card-3b {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.gwas-elevation {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.gwas-elevation:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.22), 0 10px 20px rgba(0, 0, 0, 0.25);
}

.card-3 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.93);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.card-basic {
  border: 1px solid #ccc;
}
</style>


<!--          <div class="col-lg-4 col-md-6 mg-t-10">-->
<!--            <div class="col-12 col-md-6 col-lg-12">-->
<!--              <div class="card">-->
<!--                <div class="card-body pd-y-20 pd-x-25">-->
<!--                  <div class="row row-sm">-->
<!--                    <div class="col-7">-->
<!--                      <h3 class="tx-normal tx-rubik tx-spacing&#45;&#45;1 mg-b-5">3,605</h3>-->
<!--                      <h6 class="tx-12 tx-semibold tx-uppercase tx-spacing-1 tx-primary mg-b-5">Click Through</h6>-->
<!--                      <p class="tx-11 tx-color-03 mg-b-0">No. of clicks to ad that consist of a single impression.</p>-->
<!--                    </div>-->
<!--                    <div class="col-5">-->
<!--                      <div class="chart-ten">-->
<!--                        <div id="flotChart3" class="flot-chart"></div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--              </div>&lt;!&ndash; card &ndash;&gt;-->
<!--            </div>-->
<!--            <div class="col-12 col-md-6 col-lg-12  mg-t-10">-->
<!--              <div class="card">-->
<!--                <div class="card-body pd-y-20 pd-x-25">-->
<!--                  <div class="row row-sm">-->
<!--                    <div class="col-7">-->
<!--                      <h3 class="tx-normal tx-rubik tx-spacing&#45;&#45;1 mg-b-5">8,765</h3>-->
<!--                      <h6 class="tx-12 tx-semibold tx-uppercase tx-spacing-1 tx-pink mg-b-5">Total Conversions</h6>-->
<!--                      <p class="tx-11 tx-color-03 mg-b-0">Estimated total conversions on ads per impressions to ads.</p>-->
<!--                    </div>-->
<!--                    <div class="col-5">-->
<!--                      <div class="chart-ten">-->
<!--                        <div id="flotChart5" class="flot-chart"></div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--              </div>&lt;!&ndash; card &ndash;&gt;-->
<!--            </div>-->
<!--            <div class="col-12 col-md-6 col-lg-12  mg-t-10">-->
<!--              <div class="card">-->
<!--                <div class="card-body pd-y-20 pd-x-25">-->
<!--                  <div class="row row-sm">-->
<!--                    <div class="col-7">-->
<!--                      <h3 class="tx-normal tx-rubik tx-spacing&#45;&#45;1 mg-b-5">3,266</h3>-->
<!--                      <h6 class="tx-12 tx-semibold tx-uppercase tx-spacing-1 tx-teal mg-b-5">View Through</h6>-->
<!--                      <p class="tx-11 tx-color-03 mg-b-0">Estimated daily unique views per visitor on the ads.</p>-->
<!--                    </div>-->
<!--                    <div class="col-5">-->
<!--                      <div class="chart-ten">-->
<!--                        <div id="flotChart4" class="flot-chart"></div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--              </div>&lt;!&ndash; card &ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->


<!--          <div class="col-lg-4 col-md-6 mg-t-10">-->
<!--            <div class="card">-->
<!--              <div class="card-body pd-y-20 pd-x-25">-->
<!--                <div class="row row-sm">-->
<!--                  <div class="col-7">-->
<!--                    <h3 class="tx-normal tx-rubik tx-spacing&#45;&#45;1 mg-b-5">3,266</h3>-->
<!--                    <h6 class="tx-12 tx-semibold tx-uppercase tx-spacing-1 tx-teal mg-b-5">View Through</h6>-->
<!--                    <p class="tx-11 tx-color-03 mg-b-0">Estimated daily unique views per visitor on the ads.</p>-->
<!--                  </div>-->
<!--                  <div class="col-5">-->
<!--                    <div class="chart-ten">-->
<!--                      <div id="flotChart4" class="flot-chart"></div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--            </div>&lt;!&ndash; card &ndash;&gt;-->
<!--          </div>&lt;!&ndash; col &ndash;&gt;-->
<!--          <div class="col-lg-4 col-md-6 mg-t-10">-->
<!--            <div class="card">-->
<!--              <div class="card-body pd-y-20 pd-x-25">-->
<!--                <div class="row row-sm">-->
<!--                  <div class="col-7">-->
<!--                    <h3 class="tx-normal tx-rubik tx-spacing&#45;&#45;1 mg-b-5">8,765</h3>-->
<!--                    <h6 class="tx-12 tx-semibold tx-uppercase tx-spacing-1 tx-pink mg-b-5">Total Conversions</h6>-->
<!--                    <p class="tx-11 tx-color-03 mg-b-0">Estimated total conversions on ads per impressions to ads.</p>-->
<!--                  </div>-->
<!--                  <div class="col-5">-->
<!--                    <div class="chart-ten">-->
<!--                      <div id="flotChart5" class="flot-chart"></div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--            </div>&lt;!&ndash; card &ndash;&gt;-->
<!--          </div>&lt;!&ndash; col &ndash;&gt;-->


<!--          <div class="col-lg-6 mg-t-10">-->
<!--            <div class="card">-->
<!--              <div class="card-header d-flex align-items-start justify-content-between">-->
<!--                <h6 class="lh-5 mg-b-0">Total Visits</h6>-->
<!--                <a href="" class="tx-13 link-03 d-flex align-items-center">Mar 01 - Mar 20, 2023 <ion-icon name="chevron-down-outline"></ion-icon></a>-->
<!--              </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--              <div class="card-body pd-y-15 pd-x-10">-->
<!--                <div class="table-responsive">-->
<!--                  <table class="table table-borderless table-sm tx-13 tx-nowrap mg-b-0">-->
<!--                    <thead>-->
<!--                    <tr class="tx-10 tx-spacing-1 tx-color-03 tx-uppercase">-->
<!--                      <th class="wd-5p">Link</th>-->
<!--                      <th>Page Title</th>-->
<!--                      <th class="text-right">Percentage (%)</th>-->
<!--                      <th class="text-right">Value</th>-->
<!--                    </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                    <tr>-->
<!--                      <td class="align-middle text-center"><a href=""><i data-feather="external-link" class="wd-12 ht-12 stroke-wd-3"></i></a></td>-->
<!--                      <td class="align-middle tx-medium">Homepage</td>-->
<!--                      <td class="align-middle text-right">-->
<!--                        <div class="wd-150 d-inline-block">-->
<!--                          <div class="progress ht-4 mg-b-0">-->
<!--                            <div class="progress-bar bg-teal wd-65p" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                      <td class="align-middle text-right"><span class="tx-medium">65.35%</span></td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td class="align-middle text-center"><a href=""><i data-feather="external-link" class="wd-12 ht-12 stroke-wd-3"></i></a></td>-->
<!--                      <td class="align-middle tx-medium">Our Services</td>-->
<!--                      <td class="align-middle text-right">-->
<!--                        <div class="wd-150 d-inline-block">-->
<!--                          <div class="progress ht-4 mg-b-0">-->
<!--                            <div class="progress-bar bg-primary wd-85p" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                      <td class="text-right"><span class="tx-medium">84.97%</span></td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td class="align-middle text-center"><a href=""><i data-feather="external-link" class="wd-12 ht-12 stroke-wd-3"></i></a></td>-->
<!--                      <td class="align-middle tx-medium">List of Products</td>-->
<!--                      <td class="align-middle text-right">-->
<!--                        <div class="wd-150 d-inline-block">-->
<!--                          <div class="progress ht-4 mg-b-0">-->
<!--                            <div class="progress-bar bg-warning wd-45p" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                      <td class="text-right"><span class="tx-medium">38.66%</span></td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td class="align-middle text-center"><a href=""><i data-feather="external-link" class="wd-12 ht-12 stroke-wd-3"></i></a></td>-->
<!--                      <td class="align-middle tx-medium">Contact Us</td>-->
<!--                      <td class="align-middle text-right">-->
<!--                        <div class="wd-150 d-inline-block">-->
<!--                          <div class="progress ht-4 mg-b-0">-->
<!--                            <div class="progress-bar bg-pink wd-15p" role="progressbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                      <td class="text-right"><span class="tx-medium">16.11%</span></td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td class="align-middle text-center"><a href=""><i data-feather="external-link" class="wd-12 ht-12 stroke-wd-3"></i></a></td>-->
<!--                      <td class="align-middle tx-medium">Product 50% Sale</td>-->
<!--                      <td class="align-middle text-right">-->
<!--                        <div class="wd-150 d-inline-block">-->
<!--                          <div class="progress ht-4 mg-b-0">-->
<!--                            <div class="progress-bar bg-teal wd-60p" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                      <td class="text-right"><span class="tx-medium">59.34%</span></td>-->
<!--                    </tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->
<!--              </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--            </div>&lt;!&ndash; card &ndash;&gt;-->
<!--          </div>-->
<!--          <div class="col-lg-6 mg-t-10">-->
<!--            <div class="card">-->
<!--              <div class="card-header d-sm-flex align-items-start justify-content-between">-->
<!--                <h6 class="lh-5 mg-b-0">Browser Used By Users</h6>-->
<!--                <a href="" class="tx-13 link-03 d-flex align-items-center">Mar 01 - Mar 20, 2023 <ion-icon name="chevron-down-outline"></ion-icon></a>-->
<!--              </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--              <div class="card-body pd-y-15 pd-x-10">-->
<!--                <div class="table-responsive">-->
<!--                  <table class="table table-borderless table-sm tx-13 tx-nowrap mg-b-0">-->
<!--                    <thead>-->
<!--                    <tr class="tx-10 tx-spacing-1 tx-color-03 tx-uppercase">-->
<!--                      <th class="wd-5p">&nbsp;</th>-->
<!--                      <th>Browser</th>-->
<!--                      <th class="text-right">Sessions</th>-->
<!--                      <th class="text-right">Bounce Rate</th>-->
<!--                      <th class="text-right">Conversion Rate</th>-->
<!--                    </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                    <tr>-->
<!--                      <td><i class="fab fa-chrome tx-primary op-6"></i></td>-->
<!--                      <td class="tx-medium">Google Chrome</td>-->
<!--                      <td class="text-right">13,410</td>-->
<!--                      <td class="text-right">40.95%</td>-->
<!--                      <td class="text-right">19.45%</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td><i class="fab fa-firefox tx-orange"></i></td>-->
<!--                      <td class="tx-medium">Mozilla Firefox</td>-->
<!--                      <td class="text-right">1,710</td>-->
<!--                      <td class="text-right">47.58%</td>-->
<!--                      <td class="text-right">19.99%</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td><i class="fab fa-safari tx-primary"></i></td>-->
<!--                      <td class="tx-medium">Apple Safari</td>-->
<!--                      <td class="text-right">1,340</td>-->
<!--                      <td class="text-right">56.50%</td>-->
<!--                      <td class="text-right">11.00%</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td><i class="fab fa-edge tx-primary"></i></td>-->
<!--                      <td class="tx-medium">Microsoft Edge</td>-->
<!--                      <td class="text-right">713</td>-->
<!--                      <td class="text-right">59.62%</td>-->
<!--                      <td class="text-right">4.69%</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td><i class="fab fa-opera tx-danger"></i></td>-->
<!--                      <td class="tx-medium">Opera</td>-->
<!--                      <td class="text-right">380</td>-->
<!--                      <td class="text-right">52.50%</td>-->
<!--                      <td class="text-right">8.75%</td>-->
<!--                    </tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>&lt;!&ndash; table-responsive &ndash;&gt;-->
<!--              </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--            </div>&lt;!&ndash; card &ndash;&gt;-->
<!--          </div>-->
<!--          <div class="col mg-t-10">-->
<!--            <div class="card card-dashboard-table">-->
<!--              <div class="table-responsive">-->
<!--                <table class="table table-bordered">-->
<!--                  <thead>-->
<!--                  <tr>-->
<!--                    <th>&nbsp;</th>-->
<!--                    <th colspan="3">Acquisition</th>-->
<!--                    <th colspan="3">Behavior</th>-->
<!--                    <th colspan="3">Conversions</th>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>Source</th>-->
<!--                    <th>Users</th>-->
<!--                    <th>New Users</th>-->
<!--                    <th>Sessions</th>-->
<!--                    <th>Bounce Rate</th>-->
<!--                    <th>Pages/Session</th>-->
<!--                    <th>Avg. Session</th>-->
<!--                    <th>Transactions</th>-->
<!--                    <th>Revenue</th>-->
<!--                    <th>Rate</th>-->
<!--                  </tr>-->
<!--                  </thead>-->
<!--                  <tbody>-->
<!--                  <tr>-->
<!--                    <td><a href="">Organic search</a></td>-->
<!--                    <td><strong>350</strong></td>-->
<!--                    <td><strong>22</strong></td>-->
<!--                    <td><strong>5,628</strong></td>-->
<!--                    <td><strong>25.60%</strong></td>-->
<!--                    <td><strong>1.92</strong></td>-->
<!--                    <td><strong>00:01:05</strong></td>-->
<!--                    <td><strong>340,103</strong></td>-->
<!--                    <td><strong>$2.65M</strong></td>-->
<!--                    <td><strong>4.50%</strong></td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td><a href="">Social media</a></td>-->
<!--                    <td><strong>276</strong></td>-->
<!--                    <td><strong>18</strong></td>-->
<!--                    <td><strong>5,100</strong></td>-->
<!--                    <td><strong>23.66%</strong></td>-->
<!--                    <td><strong>1.89</strong></td>-->
<!--                    <td><strong>00:01:03</strong></td>-->
<!--                    <td><strong>321,960</strong></td>-->
<!--                    <td><strong>$2.51M</strong></td>-->
<!--                    <td><strong>4.36%</strong></td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td><a href="">Referral</a></td>-->
<!--                    <td><strong>246</strong></td>-->
<!--                    <td><strong>17</strong></td>-->
<!--                    <td><strong>4,880</strong></td>-->
<!--                    <td><strong>26.22%</strong></td>-->
<!--                    <td><strong>1.78</strong></td>-->
<!--                    <td><strong>00:01:09</strong></td>-->
<!--                    <td><strong>302,767</strong></td>-->
<!--                    <td><strong>$2.1M</strong></td>-->
<!--                    <td><strong>4.34%</strong></td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td><a href="">Email</a></td>-->
<!--                    <td><strong>187</strong></td>-->
<!--                    <td><strong>14</strong></td>-->
<!--                    <td><strong>4,450</strong></td>-->
<!--                    <td><strong>24.97%</strong></td>-->
<!--                    <td><strong>1.35</strong></td>-->
<!--                    <td><strong>00:02:07</strong></td>-->
<!--                    <td><strong>279,300</strong></td>-->
<!--                    <td><strong>$1.86M</strong></td>-->
<!--                    <td><strong>3.99%</strong></td>-->
<!--                  </tr>-->
<!--                  </tbody>-->
<!--                </table>-->
<!--              </div>&lt;!&ndash; table-responsive &ndash;&gt;-->
<!--            </div>&lt;!&ndash; card &ndash;&gt;-->
<!--          </div>-->
